import React, { useEffect, useContext, useReducer, useState } from 'react';
import { GET_USER, SET_LOGIN_STATUS } from '../actions';
import reducer from '../reducers/homepage_reducer';
import customFetch from '../utils/customFetch';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const fetchUser = async () => {
  try {
    const { data } = await customFetch.get('/users/current-user');
    console.log(data);
    return data.user;
  } catch (error) {
    throw error;
  }
};

const logoutUser = async () => {
  const navigate = useNavigate();
  navigate('/');
  await customFetch.delete('/auth/logout');
  toast.success('Ausgeloggt');
};

const initialState = {
  user: null,
  isLoggedIn: false,
};

const HomepageContext = React.createContext();

export const HomepageProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const getUser = (storedUser) => {
    dispatch({
      type: GET_USER,
      payload: storedUser,
    });
  };

  const loginStatus = (isLoggedIn) => {
    dispatch({
      type: SET_LOGIN_STATUS,
      payload: isLoggedIn,
    });
  };

  // Logout Logic

  // useEffect(() => {
  //   const checkUser = async () => {
  //     try {
  //       const storedUser = localStorage.getItem('user');
  //       if (storedUser) {
  //         getUser(JSON.parse(storedUser));
  //         loginStatus(true);
  //       } else {
  //         const user = await fetchUser();
  //         localStorage.setItem('user', JSON.stringify(user));
  //         console.log(user);
  //         getUser(user);
  //         loginStatus(true);
  //       }
  //     } catch (error) {
  //       // Handle failure (user not logged in or token expired)
  //       loginStatus(false);
  //       localStorage.removeItem('user');
  //     }
  //   };
  //   checkUser();
  // }, []); // dispatch is stable, so it's not needed as a dependency

  return (
    <HomepageContext.Provider value={{ ...state, loginStatus }}>
      {children}
    </HomepageContext.Provider>
  );
};

// make sure use
// export const useHomepageContext = () => {
//   return useHomepageContext(HomepageContext);
// };

export const useHomepageContext = () => useContext(HomepageContext);
